import { ReactComponent as ClearInput } from 'assets/icons/x-mui-icon.svg'

import { IconStyles } from '../types'
import { ClearInputCustom } from './styles'
interface ClearInputIconProps extends IconStyles {
  onClick?: any
}

const ClearInputIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon
}: ClearInputIconProps) => {
  return (
    <ClearInputCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
    >
      <ClearInput />
    </ClearInputCustom>
  )
}

export default ClearInputIcon
